import { render, staticRenderFns } from "./ParkingCoupons.vue?vue&type=template&id=58ec39b1&scoped=true"
import script from "./ParkingCoupons.vue?vue&type=script&lang=js"
export * from "./ParkingCoupons.vue?vue&type=script&lang=js"
import style0 from "./ParkingCoupons.vue?vue&type=style&index=0&id=58ec39b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec39b1",
  null
  
)

export default component.exports